import emails from '@/reducers/emails/emails.redux'
import sso from '@/reducers/auth/sso.redux'
import mfa from '@/reducers/auth/mfa.redux'
import activityLog from './realtime/activityLog/activityLog.redux'
import analytics from './analytics/analytics.redux'
import baltoGPT from './baltoGPT/baltoGPT.redux'
import bulkScoring from './bulkScoring/bulkScoring.redux'
import callSearch from './callSearch/callSearch.redux'
import commandCenter from './commandCenter/commandCenter.redux'
import outboundContactLists from './outbound/outboundContactLists.redux'
import currentOrganization from './auth/currentOrganization.redux'
import currentUser from './auth/currentUser.redux'
import customBranding from './customBranding/customBranding.redux'
import customColumns from './customColumns/customColumns.redux'
import insightEvents from './insights/insightEvents.redux'
import integrations from './integrations/integrations.redux'
import keywords from './keywords/keywords.redux'
import leaderboards from './leaderboards/leaderboards.redux'
import media from './media/media.redux'
import messages from './messages/messages.redux'
import notes from './notes/notes.redux'
import notifications from './notifications/notifications.redux'
import organization from './organizations/organization.redux'
import organizationCustomBranding from './organizations/organizationCustomBranding.redux'
import organizations from './organizations/organizations.redux'
import emailIngestionBlocklist from './organizations/emailIngestionBlocklist.redux'
import organizationTagCategories from './organizations/organizationTagCategories.redux'
import organizationTagManager from './organizations/organizationTagManager.redux'
import organizationTags from './organizations/organizationTags.redux'
import organizationUsers from './organizations/organizationUsers.redux'
import organizationUsersCSV from './organizations/organizationUsersCSV.redux'
import organizationVoipCampaignsCSV from './organizations/organizationVoipCampaignsCSV.redux'
import organizationVoipCampaigns from './organizations/organizationVoipCampaigns.redux'
import orgHierarchy from './orgHierarchy/orghierarchy.redux'
import playbook from './playbooks/playbook.redux'
import playbooks from './playbooks/playbooks.redux'
import callAssetExports from './callAssetExports/callAssetExports.redux'
import playlists from './playlists/playlists.redux'
import prompts from './prompts/prompts.redux'
import voiceAgents from './voiceAgents/voiceAgents.redux'
import voiceAgentsAnalytics from './voiceAgents/voiceAgentsAnalytics.redux'
import promptFeedback from './promptFeedback/promptFeedback.redux'
import promptimizer from './promptimizer/promptimizer.redux'
import costimizer from './costimizer/costimizer.redux'
import qaCopilot from './qa-copilot/qa-copilot.redux'
import realtimeAdvancedExports from './realtime/advancedExports/advancedExports.redux'
import realtimeChats from './realtime/realtimeChats.redux'
import liveTranscripts from './realtime/liveTranscripts.redux'
import realtimeCoaching from './realtime/realtimeCoaching/realtimeCoaching.redux'
import realtimeNewAlertConfiguration from './realtime/alerts/realtimeNewAlertConfiguration.redux'
import realtimeOrganizationAlertConfigurations from './realtime/alerts/realtimeOrganizationAlertConfigurations.redux'
import realtimeReports from './realtime/reports/realtimeReports.redux'
import realtimeSocket from './realtime/realtimeSocket.redux'
import realtimeUserAlerts from './realtime/alerts/realtimeUserAlerts.redux'
import savedFilters from './savedFilters/savedFilters.redux'
import userSettings from './userSettings/userSettings.redux'
import scorecards from './scorecards/scorecards.redux'
import tasks from './tasks/tasks.redux'
import ui from './ui/ui.redux'
import featureFeedback from './featureFeedback/featureFeedback.redux'
import dynamicInsightEvents from './insights/dynamicInsightEvents.redux'
import recentQuestions from './recentQuestions/recentQuestions.redux'
import audioIngestion from './audioIngestion/audioIngestion.redux'
import trends from './insights/trends.redux'
import agenticInsights from './insights/agenticInsights.redux'
import dataCleanup from './dataCleanup/dataCleanup.redux'
import baltoAcademy from './baltoAcademy/baltoAcademy.redux'
import tools from './tools/tools.redux'
import outboundCampaigns from './outbound/outboundCampaigns.redux'
import outboundScheduledCalls from './outbound/outboundScheduledCalls.redux'
import kodi from './kodi/kodi.redux'
import omnichannelUsage from './omnichannelUsage/omnichannelUsage.redux'
import supportAccess from './supportAccess/supportAccess.redux'
import agentProvisioning from './agentProvisioning/agentProvisioning.redux'

const reducers = {
  activityLog,
  agentProvisioning,
  agenticInsights,
  analytics,
  baltoGPT,
  bulkScoring,
  callSearch,
  commandCenter,
  kodi,
  currentOrganization,
  currentUser,
  customBranding,
  customColumns,
  emails,
  insightEvents,
  integrations,
  keywords,
  leaderboards,
  media,
  messages,
  notes,
  notifications,
  organization,
  emailIngestionBlocklist,
  organizationCustomBranding,
  organizations,
  organizationTagCategories,
  organizationTagManager,
  organizationTags,
  organizationUsers,
  organizationUsersCSV,
  organizationVoipCampaignsCSV,
  organizationVoipCampaigns,
  outboundCampaigns,
  outboundScheduledCalls,
  orgHierarchy,
  outboundContactLists,
  playbook,
  playbooks,
  callAssetExports,
  playlists,
  prompts,
  voiceAgents,
  voiceAgentsAnalytics,
  promptFeedback,
  promptimizer,
  costimizer,
  qaCopilot,
  realtimeAdvancedExports,
  realtimeChats,
  liveTranscripts,
  realtimeCoaching,
  realtimeNewAlertConfiguration,
  realtimeOrganizationAlertConfigurations,
  realtimeReports,
  realtimeSocket,
  realtimeUserAlerts,
  savedFilters,
  scorecards,
  userSettings,
  sso,
  mfa,
  tasks,
  ui,
  featureFeedback,
  dynamicInsightEvents,
  recentQuestions,
  audioIngestion,
  trends,
  dataCleanup,
  baltoAcademy,
  tools,
  omnichannelUsage,
  supportAccess,
}

export default reducers
